<template>
    <v-row>
        <v-col v-for="work in works" :key="work._id" cols="12" sm="6" md="4" lg="3">
            <auction-work-item :work="work" />
        </v-col>
    </v-row>
</template>

<script>
import AuctionWorkItem from "./auction-work-item.vue";
export default {
    components: { AuctionWorkItem },
    props: ["works"],
};
</script>

<style>
</style>